module.exports = __webpack_public_path__ + "img/Suv_Side_Left.ffde1d3b.svg";